import ufeApi from 'services/api/ufeApi';

function getCustomerPreferences(profileId) {
    const url = `/gway/v1/preferences/profiles/${profileId}/beautyInsiderAccount`;

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default getCustomerPreferences;
